const modals = document.querySelectorAll(".js-modal");

modals.forEach(modal => {
    const closeButtons = modal.querySelectorAll(".js-modal-close");

    closeButtons.forEach(closeButton => {
        closeButton.addEventListener("click", () => {
            modal.classList.remove("c-modal--open");
        });
    });
});